import React from 'react';
import styles from './header-secondary.scss';
import { Textarea } from 'ui';
import { CodeMappingsTranslation } from 'app/area/code-mappings/constants';

export interface HeaderSecondaryProps {
  fileName: string;
  importSet: string;
  translation: CodeMappingsTranslation;
}

export const HeaderSecondary: React.FC<HeaderSecondaryProps> =
  ({ fileName, importSet, translation }) =>
    <div className={styles.container}>
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          <Textarea
            componentId={'import-set'}
            value={importSet}
            label={{ text: translation.import_set }}
            readOnly={true} />
        </div>
        <div className="col-lg-6 col-sm-12">
          <Textarea
            componentId={'file-name'}
            value={fileName}
            label={{ text: translation.file_name }}
            readOnly={true} />
        </div>
      </div>
    </div>
